export type BulkJobStatus = 'running' | 'finished' | 'failed' | 'cancelled';

export const BULK_UPDATE_QUEUE = 'bulk-update' as const;

export type BulkResultStatus = 'pending' | 'succeeded' | 'failed' | 'skipped-already-assigned' | 'cancelled';

export type BulkPreviewBucket = 'new' | 'alreadyAssigned' | 'conflictOpen' | 'historicalOnly';

export interface BulkBuckets {
  new: number;
  alreadyAssigned: number;
  conflictOpen: number;
  historicalOnly: number;
}

export interface BulkTotals {
  succeeded: number;
  failed: number;
  skipped: number;
  cancelled: number;
}

export interface BulkJobSummary {
  id: string;
  mode: 'preview' | 'apply';
  resourceKey: string;
  collectionKey: string;
  status?: BulkJobStatus;
  createdAt: string;
  completedAt?: string | null;
  bucketsSummary?: BulkBuckets;
  totals?: BulkTotals;
}

export interface BulkJobResult {
  id?: string;
  entityId: string;
  status: BulkResultStatus;
  bucket?: BulkPreviewBucket;
  reason?: string;
  appliedPatch?: Record<string, unknown>;
}

export interface BulkJobRehydration {
  job: BulkJobSummary;
  results: BulkJobResult[];
  total: number;
  patchSnapshot?: {
    patch?: Record<string, { op: 'set' | 'clear'; value?: unknown }>;
    arrayOps?: Record<string, { op: 'append' | 'remove'; items: unknown[]; closePreviousOpen?: boolean }>;
  };
  closePreviousOpen?: boolean;
}

export type BulkSelectionFilterValue = string | number | boolean;

export interface BulkSelectionFilter {
  query: {
    search: string;
    filter: string[];
  };
  filterValues?: Record<string, BulkSelectionFilterValue[]>;
  filterValue?: BulkSelectionFilterValue;
  sortBy?: string;
  sortDirection?: 'asc' | 'desc';
}

export type BulkSelectionPayload = { ids: string[] } | { filter: BulkSelectionFilter; excludeIds?: string[] };

export interface BulkEditPayload {
  selection: BulkSelectionPayload;
  patch?: Record<string, { op: 'set' | 'clear'; value?: unknown }>;
  arrayOps?: Record<string, { op: 'append' | 'remove'; items: unknown[]; closePreviousOpen?: boolean }>;
  dryRun?: boolean;
}

export interface BulkStartResponse {
  jobId: string;
  backgroundJobId?: string;
}
